export default __webpack_public_path__ + "static/media/apple.251bab9c.png";